import React from 'react';
import { Avatar } from '@shoflo/polymer/components/Avatar/Avatar';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AdminListItemMenu from 'components/event/CrewListItemMenu';

const StyledTD = styled.td`
  border-top: none !important;
  border-bottom: 2px solid #f0f2f6;
  vertical-align: middle !important;
  padding: 1rem 0 !important;
`;

const UserWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledUserName = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #333333;
  margin-left: 55px;

  @media only screen and (max-width: 768px) {
    margin-left: 10px;
  }
`;

const StyledEm = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: #767676;
`;

const StyledEventSettings = styled(StyledTD)`
  text-align: right;

  .dropdown-menu.show {
    width: 200px;
    left: auto !important;
    right: 0;
    transform: translate3d(0px, 34px, 0px) !important;
  }
`;

const AdminListItem = React.memo(
  ({ user, currentUserId, onDeleteClick, onResendInviteClick }) => {
    return (
      <tr>
        <StyledTD>
          <UserWrapper>
            <Avatar user={user} />
            <div>
              <StyledUserName
                className="dd-privacy-mask"
                data-testid={`name-${user.firstName}-${user.lastName}`}
              >
                {user.firstName} {user.lastName}
              </StyledUserName>
            </div>
          </UserWrapper>
        </StyledTD>
        <StyledTD className="d-none d-lg-table-cell">
          <StyledEm
            className="dd-privacy-mask"
            data-testid={`email-${user.email}`}
          >
            {user.email}
          </StyledEm>
        </StyledTD>
        <StyledEventSettings>
          {user._id !== currentUserId && (
            <AdminListItemMenu
              showRemove={true}
              showResend={user.pending}
              onResend={onResendInviteClick.bind(null, user._id)}
              onDelete={onDeleteClick.bind(null, user._id)}
            />
          )}
        </StyledEventSettings>
      </tr>
    );
  },
);

AdminListItem.displayName = 'AdminListItem';

AdminListItem.propTypes = {
  user: PropTypes.object.isRequired,
  onResendInviteClick: PropTypes.func,
  onDeleteClick: PropTypes.func.isRequired,
};

export default AdminListItem;
